import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import { CloseXIcon } from "../ChatiaIcons";
import ChatiaDialogActions from "../ChatiaDialogActions";

const useStyles = makeStyles(theme => ({
	dialogPaper: {
		borderRadius: "21px 21px 12px 12px !important",
		maxHeight: "85vh !important",
		display: "flex !important",
		flexDirection: "column !important",
		overflow: "hidden !important",
		backgroundColor: theme.mode === "light" ? "#ffffff !important" : `${theme.palette.darkDialogSurface || "#121212"} !important`,
		backgroundImage: "none !important",
		"& form": {
			display: "flex",
			flexDirection: "column",
			flex: 1,
			minHeight: 0,
			overflow: "hidden",
		},
		"& .MuiDialogContent-root": {
			flex: 1,
			overflowY: "auto !important",
			overflowX: "hidden",
			...theme.scrollbarStyles,
		},
		"& .MuiDialogActions-root": {
			flexShrink: 0,
		},
		"& .MuiOutlinedInput-root": {
			borderRadius: "12px !important",
		},
		"& .MuiOutlinedInput-notchedOutline": {
			borderRadius: "12px !important",
		},
		"& .MuiSelect-outlined": {
			borderRadius: "12px !important",
		},
		"& .react-tel-input .form-control": {
			borderRadius: "12px !important",
		},
		"& .MuiCheckbox-root .MuiSvgIcon-root": {
			fontSize: 18,
			borderRadius: 4,
		},
		"& .MuiSelect-icon": {
			right: 8,
			top: "50%",
			transform: "translateY(-50%)",
		},
		// Autocomplete — popup indicator e clear com estilo
		"& .MuiAutocomplete-inputRoot.MuiOutlinedInput-root": {
			borderRadius: "12px !important",
			paddingRight: "56px !important",
		},
		"& .MuiAutocomplete-endAdornment": {
			right: "8px !important",
		},
		"& .MuiAutocomplete-popupIndicator": {
			padding: 4,
			color: theme.mode === "light" ? "#667781" : "#8696a0",
		},
		"& .MuiAutocomplete-clearIndicator": {
			padding: 4,
			color: theme.mode === "light" ? "#667781" : "#8696a0",
		},
		// Datetime-local — estilizar o input nativo
		"& input[type='datetime-local']": {
			fontFamily: "inherit",
			fontSize: 14,
			color: theme.mode === "light" ? "#111b21" : "#e9edef",
		},
		"& input[type='datetime-local']::-webkit-calendar-picker-indicator": {
			filter: theme.mode === "dark" ? "invert(0.8)" : "none",
			cursor: "pointer",
			opacity: 0.6,
			padding: 2,
			borderRadius: 4,
			transition: "all 0.2s ease",
			"&:hover": {
				opacity: 1,
				backgroundColor: theme.mode === "light" ? "rgba(0,0,0,0.06)" : "rgba(255,255,255,0.08)",
			},
		},
	},
	header: {
		...theme.chatiaDS.header,
		flexShrink: 0,
	},
	headerTitle: {
		...theme.chatiaDS.headerTitle,
	},
	closeButton: {
		backgroundColor: theme.chatiaDS.closeButton.backgroundColor,
		color: theme.chatiaDS.closeButton.color,
		transition: theme.chatiaDS.closeButton.transition,
	},
}));

const ChatiaDialog = ({
	open,
	onClose,
	title,
	maxWidth = "md",
	scroll = "paper",
	fullWidth = true,
	contentDividers = true,
	// Footer props (optional — pass onSave to show footer)
	onSave,
	saveText,
	saveType = "submit",
	saveDisabled,
	saveLoading,
	footerChildren,
	// Se true, não renderiza footer (para quando o form tem seu próprio submit)
	hideFooter,
	children,
}) => {
	const classes = useStyles();

	return (
		<Dialog
			open={open}
			onClose={onClose}
			maxWidth={maxWidth}
			fullWidth={fullWidth}
			scroll={scroll}
			PaperProps={{ className: classes.dialogPaper }}
		>
			{/* Header */}
			<div className={classes.header}>
				<Typography className={classes.headerTitle}>
					{title}
				</Typography>
				<IconButton
					size="small"
					onClick={onClose}
					className={classes.closeButton}
					onMouseEnter={(e) => {
						e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.18)";
						e.currentTarget.style.color = "#ffffff";
					}}
					onMouseLeave={(e) => {
						e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.08)";
						e.currentTarget.style.color = "#ffffff";
					}}
				>
					<CloseXIcon style={{ fontSize: 18 }} />
				</IconButton>
			</div>

			{/* Content */}
			<DialogContent dividers={contentDividers}>
				{children}
			</DialogContent>

			{/* Footer */}
			{!hideFooter && onSave && (
				<ChatiaDialogActions
					onClick={onSave}
					type={saveType}
					disabled={saveDisabled}
					loading={saveLoading}
					saveText={saveText || "Salvar"}
				>
					{footerChildren}
				</ChatiaDialogActions>
			)}
			{!hideFooter && !onSave && saveType === "submit" && (
				<ChatiaDialogActions
					type="submit"
					disabled={saveDisabled}
					loading={saveLoading}
					saveText={saveText || "Salvar"}
				>
					{footerChildren}
				</ChatiaDialogActions>
			)}
		</Dialog>
	);
};

export default ChatiaDialog;
export { default as ChatiaToggleItem } from "./ChatiaToggleItem";
export { default as ChatiaPromptField } from "./ChatiaPromptField";
